<template>
  <v-row id="HorseDetail" no-gutters>
    <v-col cols="8">
      <HorseEvents :horse="horse" />
    </v-col>
    <v-col cols="4">
      <HorseInfoDetail :horse="horse" />
    </v-col>
  </v-row>
</template>

<script>
import HorseInfoDetail from './HorseInfoDetail.vue';
import HorseEvents from './HorseEvents.vue';

export default {
  components: { HorseInfoDetail, HorseEvents },
  props: {
    horse: {
      type: Object,
      default () {
        return {};
      }
    }
  }
};
</script>
